const ja = {
  common: {
    loading: '読み込み中...',
    error: 'エラーが発生しました',
    cancel: 'キャンセル',
    save: '保存',
    saving: '保存中...',
    copy: 'コピー',
    copied: 'コピーしました！',
    goHome: 'ホームへ',
    back: '戻る',
    playAudyn: 'Audynをプレイ',
    reload: 'リロード',
    or: 'または',
    you: 'あなた',
    vs: 'VS',
    songs: '曲',
    tracks: 'トラック',
    score: 'スコア',
    rank: 'ランク',
    correct: '正解',
    accuracy: '正解率',
    today: '今日',
    daily: 'デイリー',
    streak: '連続',
    profile: 'プロフィール',
    guest: 'ゲスト',
  },

  nav: {
    dailyChallenge: 'デイリーチャレンジ',
    leaderboard: 'ランキング',
    profile: 'プロフィール',
    logIn: 'ログイン',
  },

  home: {
    title: '曲を当てよう',
    subtitle: 'Spotifyのプレイリストを貼り付け、クリップを聴いて、曲名を当てよう。',
    playersToday: '今日のプレイヤー数: {count}人',
    playlistInput: 'https://open.spotify.com/playlist/...',
    loadPlaylist: 'プレイリストを読み込む',
    tryDemo: 'デモを試す — Today\'s Top Hits',
    recentlyPlayed: '最近プレイした',
    featuredPlaylists: '人気のプレイリスト',
    songs: '曲',
    difficulty: '難易度',
    gameMode: 'ゲームモード',
    guessMode: '解答モード',
    clips: 'クリップ',
    startGame: 'ゲーム開始',
    challengeFriend: '⚔️ フレンドに挑戦',
    changePlaylist: 'プレイリストを変更',
    playableTracks: '再生可能: {count}トラック',
    playableOfTotal: '再生可能: {total}トラック中{playable}',
    allGuessable: '{total}曲すべてが解答候補に含まれます',
    loadingPreviews: 'プレビューを読み込み中…',
    back: '戻る',
    backToPlaylist: 'プレイリスト選択に戻る',

    beatScore: '⚔️ {username}のスコア{score}を超えよう！',

    announcement: {
      title: '🎉 大規模プレイリストに対応しました！',
      message: '100曲以上のプレイリストがサポートされました。読み込みに少し時間がかかる場合があります。',
    },

    easy: 'イージー',
    easyDesc: '長いクリップ、考える時間が多い',
    normal: 'ノーマル',
    normalDesc: '標準的な体験',
    hard: 'ハード',
    hardDesc: '一瞬で聞き逃す',
    classic: 'クラシック',
    classicDesc: 'クリップステージのみでスコア。時間制限なし。',
    tickingAway: 'タイムアタック',
    tickingAwayDesc: '時間が経つほどスコアが減る。一秒一秒が大切。',
    songTitle: '曲名',
    songTitleDesc: 'トラック名を当てる',
    artist: 'アーティスト',
    artistDesc: 'アーティスト名を当てる',
  },

  game: {
    tapToBegin: 'タップして開始',
    tapToUnlock: '画面をタップしてオーディオを有効にしてください',
    listening: '再生中...',
    ready: '準備完了',
    tapReplay: 'もう一度再生',
    loadingAudio: '読み込み中...',
    skipped: 'スキップ',
    audioError: 'オーディオエラー',
    typeGuess: '答えを入力...',
    typeArtist: 'アーティスト名を入力...',
    checking: '判定中...',
    skip: 'スキップ',
    timePressure: 'タイムプレッシャー',
    nextSong: '次の曲へ',
    seeResults: '結果を見る',
    betterLuck: '次はがんばろう',
    correctArtist: 'アーティスト正解！',
    theArtistWas: 'アーティスト: {artist}',
    openInSpotify: 'Spotifyで開く',
    base: '基本',
    timePenalty: 'タイムペナルティ',
    streakMultiplier: '× {mult} 連続ボーナス',
    kbPlay: '[Space] 再生',
    kbGuess: '[Enter] 回答',
    kbClear: '[Esc] クリア',
  },

  end: {
    newPersonalBest: '🏆 自己ベスト更新！',
    copyLink: 'リンクをコピー',
    copyShareText: 'シェアテキストをコピー',
    challengeFriend: 'フレンドに挑戦',
    copyManually: '手動でコピー:',
    playAgain: 'もう一度プレイ',
    newPlaylist: '新しいプレイリスト',
    viewLeaderboard: 'ランキングを見る',
    createAccount: 'アカウントを作成してスコアを保存し、バッジを獲得しよう',
    signUp: '新規登録',
    outOf: '{max}点中',
    missedTracks: '不正解のトラック',
    scoreCard: 'スコアカード',
    shareText: '{playlist}で{score}/{max}を獲得 🎵 ({difficulty} • {tracks}曲) — あなたは勝てる？ {link}',
  },

  daily: {
    title: 'デイリーチャレンジ',
    todaysChallenge: '今日のチャレンジ',
    classicMode: '🎵 クラシックモード • 時間制限なし',
    playToday: '今日のチャレンジをプレイ',
    alreadyPlayed: '✅ 今日のチャレンジは完了済みです',
    signInToSave: 'デイリー連続記録を保存するにはサインインしてください',
    firstDay: '初日です！続けましょう。',
    dayStreak: '{count}日連続',
    couldNotLoad: 'デイリーチャレンジを読み込めませんでした',
    needsCache: 'デイリープレイリストはキャッシュのために一度再生する必要があります。',
    alreadyPlayedToast: '今日のチャレンジはすでにプレイ済みです！',
  },

  leaderboard: {
    title: 'ランキング',
    global: '🏆 グローバル',
    daily: '📅 デイリー',
    allTime: '全期間',
    month: '月間',
    week: '週間',
    noEntries: 'まだエントリーがありません',
    beFirst: '最初のプレイヤーになりましょう！',
    yourRank: 'あなたの順位',
    rankedByTimePressure: 'タイムプレッシャーでのスコア順',
    classicMode: '🎵 クラシック',
    tickingMode: '⏱️ タイムアタック',
    songMode: '🎵 曲名',
    artistMode: '🎤 アーティスト',
  },

  login: {
    title: 'ログイン',
    email: 'メールアドレス',
    emailPlaceholder: 'you@example.com',
    password: 'パスワード',
    passwordPlaceholder: '••••••••',
    logInBtn: 'ログイン',
    signingIn: 'ログイン中...',
    noAccount: 'アカウントをお持ちでないですか？',
    signUpLink: '新規登録',
    welcomeBack: 'おかえりなさい！',
    fillFields: 'すべてのフィールドを入力してください',
    loginFailed: 'ログインに失敗しました',
  },

  register: {
    title: '新規登録',
    saveProgress: '進捗を保存',
    saveProgressDesc: 'ランキングにスコアを残すためにアカウントを作成してください。',
    username: 'ユーザー名',
    usernamePlaceholder: 'your_username',
    email: 'メールアドレス',
    emailPlaceholder: 'you@example.com',
    password: 'パスワード',
    passwordPlaceholder: '8文字以上',
    bio: '自己紹介',
    bioPlaceholder: '自分について少し...',
    optional: '任意',
    createAccount: 'アカウント作成',
    saveAccount: 'アカウント保存',
    creating: '作成中...',
    haveAccount: 'すでにアカウントをお持ちですか？',
    logInLink: 'ログイン',
    welcomeToAudyn: 'Audynへようこそ！',
    accountCreated: 'アカウントが作成されました！スコアは保持されます。',
    fillRequired: '必須フィールドをすべて入力してください',
    passwordMin: 'パスワードは8文字以上必要です',
    registrationFailed: '登録に失敗しました',
  },

  profile: {
    title: 'プロフィール',
    editProfile: 'プロフィールを編集',
    displayName: '表示名',
    displayNamePlaceholder: '表示名（任意）',
    displayNameHint: '{count}/50 — 空欄の場合ユーザー名が表示されます',
    bioPlaceholder: '短い自己紹介を書いてください...',
    spotify: 'Spotify',
    spotifyPlaceholder: 'https://open.spotify.com/user/your_id',
    spotifyError: 'https://open.spotify.com/user/ で始まる必要があります',
    instagram: 'Instagram',
    instagramError: '英数字、アンダースコア、ピリオドのみ（1～30文字）',
    pinterest: 'Pinterest',
    pinterestError: '英数字、アンダースコア、ピリオドのみ（3～30文字）',
    achievements: '実績',
    playToEarn: 'ゲームをプレイして実績を獲得しよう！',
    recentScores: '最近のスコア',
    profileUpdated: 'プロフィールを更新しました',
    avatarUpdated: 'アバターを更新しました',
    profileLinkCopied: 'プロフィールリンクをコピーしました！',
    signInToView: 'プロフィールを見るにはサインインしてください',
    onlyJpgPngWebp: 'JPEG、PNG、WebPのみ対応',
  },

  publicProfile: {
    userNotFound: 'ユーザーが見つかりません',
    userNotExist: 'このユーザーは存在しません。',
  },

  share: {
    shareNotFound: 'シェアが見つかりません',
    shareExpired: 'このシェアリンクは期限切れまたは存在しません。',
    playThisPlaylist: 'このプレイリストをプレイ',
    goToAudyn: 'Audynへ',
  },

  room: {
    roomCode: 'ルームコード',
    waitingForOpponent: '対戦相手を待っています...',
    shareCodeHint: 'コードまたはリンクを共有してください。ルームは30分で期限切れです。',
    cancelRoom: 'キャンセル',
    opponent: '対戦相手',
    playAgain: 'もう一度プレイ',
    wonBy: '{diff}ポイント差で勝利！ 🏆',
    tie: '引き分け！',
    lostBy: '{diff}ポイント差で敗北',
    h2hChallenge: '対戦チャレンジ',
    roomLinkCopied: 'ルームリンクをコピーしました！',
    challengeLinkCopied: 'チャレンジリンクをコピーしました！友達に送ってください。',
    noPlaylist: 'プレイリストが選択されていません — まずプレイリストを読み込んでください。',
  },

  errorBoundary: {
    title: 'エラーが発生しました。',
    message: 'ページをリロードしてやり直してください。',
    reload: 'リロード',
  },

  languages: {
    en: 'English',
    hi: 'हिन्दी',
    es: 'Español',
    ja: '日本語',
    ko: '한국어',
  },
};

export default ja;
